import React from 'react';
import PropTypes from 'prop-types';

import Upload from 'containers/TachyReport/Upload';
import Summary from 'containers/TachyReport/Summary';

const TachyReport = ({ isTachyReport, isResearcher, patientId, lastUpdated, id }) => (
  <>
    {isTachyReport ? (
      <Summary id={id} patientId={patientId} lastUpdated={lastUpdated} />
    ) : (
      isResearcher && <Upload />
    )}
  </>
);

TachyReport.propTypes = {
  patientId: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isTachyReport: PropTypes.bool.isRequired,
  isResearcher: PropTypes.bool.isRequired,
};

export default TachyReport;
